import { Keys, StorageService } from '../../../../../service/storage.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddFundPopupComponent } from '../../add-fund-popup/add-fund-popup.component'
import { LenderApplicationStatus, LenderBasicInfo } from '../../../../../model/lender.model';
import { UserAttributeService } from '../../../../../service/finzy-flex/user/user-attribute.service';
import { ConfigService } from '../../../../../service/config.service';
import { Toaster, Type } from '../../../../../toaster/Toaster';
import { AttributeCode, AttributeValue, InvestmentPreference, InvestmentPreferences } from '../../../../../model/finzy-flex/user-attribute.model';
import { ProductService } from '../../../../../service/finzy-flex/product/product.service';
import { ProductCode, ProductDataForNCash, ProductDataForSwift, ProductDetails, ProductList, TypeForNCash } from '../../../../../model/finzy-flex/product-list.model';
import { Router } from '@angular/router';
import { FfEndPoints } from '../../ff-endpoints';

@Component({
  selector: 'app-kyc-preference',
  templateUrl: './kyc-preference.component.html',
  styleUrls: ['./kyc-preference.component.css']
})
export class KycPreferenceComponent implements OnInit {

  isPreferenceSet: boolean = false;
  private readonly userAttributeService: UserAttributeService;
  private readonly storageService: StorageService;
  private readonly productService: ProductService;
  private readonly matDialog: MatDialog;
  private readonly configService: ConfigService;
  private readonly router: Router
  public fundAllocationMinimumAmount: number;
  public lenderBasicInfo: LenderBasicInfo;
  public lenderApplicationStatus: string;
  public kycStatusImage: string;
  public isPortfolioPresent: boolean = false;
  public productAttributes: InvestmentPreference[] = [];
  public listOfAllSubProduct: ProductList;
  public productsDataForSwift: ProductDataForSwift[] = [];
  public productDataForNCash: ProductDataForNCash;
  preferenceValue = {
    isNCash: false,
    isSwift: false,
    walletAmount: 0
  }

  constructor(storageService: StorageService, matDialog: MatDialog,
    userAttributeService: UserAttributeService, configService: ConfigService, productService: ProductService,
    router: Router) {
    this.storageService = storageService;
    this.matDialog = matDialog;
    this.userAttributeService = userAttributeService;
    this.configService = configService;
    this.productService = productService;
    this.router = router;
  }

  async ngOnInit() {
    await this.getSubProductsList();
    await this.getUserAttributes();
    await this.getLenderBasicInfo();
    this.getFundAllocationMinimumAmount();
  }

  private getFundAllocationMinimumAmount() {
    if (!this.lenderBasicInfo?.portfolioPresent) {
      this.fundAllocationMinimumAmount = this.configService.getInitialFundAllocationMinAmount();
    } else {
      this.fundAllocationMinimumAmount = this.configService.getFundAllocationMinAmount();
    }
  }

  private checkDateRange(productList: ProductList): ProductDetails[] {
    let filteredProduct: ProductDetails[] = [];
    productList.data.forEach(async (product) => {
      if (new Date(product.productVersions[0]?.startDate).getTime() <= new Date().getTime() &&
        new Date().getTime() <= new Date(product.productVersions[0]?.endDate).getTime()) {
        await filteredProduct.push(product);
      }
    });
    return filteredProduct;
  }

  private populateDataForNCashDetails(preferences: InvestmentPreferences) {
    preferences.investmentPreferences.forEach((investmentPreference) => {
      switch (investmentPreference.attributeCode) {
        case AttributeCode.NCASH_WD_FREQUENCY.toString():
          this.productDataForNCash.frequency = investmentPreference.attributeValue.toString();
          break;
        case AttributeCode.NCASH_WD_DATE_OF_MONTH.toString():
          this.productDataForNCash.date = investmentPreference.attributeValue.toString();
          break;
        case AttributeCode.NCASH_WD_LIMIT.toString():
          this.productDataForNCash.type = TypeForNCash[investmentPreference.attributeValue] ?? investmentPreference.attributeValue;
          break;
      }
      if ((investmentPreference?.productCode != undefined) && (investmentPreference?.productVersion != undefined)) {
        this.productAttributes.push(investmentPreference);
      }
    });
  }

  private checkForPreferenceAndType(preference: InvestmentPreferences) {
    this.isPreferenceSet = true;
    if (preference.investmentPreferences.find(preference => preference.attributeCode === AttributeCode.NCASH_WD_LIMIT)) {
      this.preferenceValue.isNCash = true;
    }
    if (preference.investmentPreferences.find(preference => preference.attributeCode === AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE && preference.attributeValue === AttributeValue.SWIFT)) {
      this.preferenceValue.isSwift = true;
    }
  }

  private async populateDataForSwiftDetails(productDataDetail: ProductDetails[]) {
    this.productsDataForSwift = [];
    this.productAttributes.forEach((productAttribute) => {
      const hasProductAttribute = productDataDetail.find(product => product.code === productAttribute.productCode);
      if (hasProductAttribute) {
        const productDataForSwift: ProductDataForSwift = {
          name: hasProductAttribute.productVersions[0].productAttributes.find(attribute => attribute.code == ProductCode.NAME) ? hasProductAttribute.productVersions[0].productAttributes.find(attribute => attribute.code == ProductCode.NAME).value.toString() : hasProductAttribute.name,
          mph: (hasProductAttribute.productVersions.length > 0) && hasProductAttribute.productVersions[0].productAttributes.find(attribute => attribute.code === ProductCode.MHP_FRONTEND_DISPLAY)?.value.toString(),
          interest: (hasProductAttribute.productVersions.length > 0) && hasProductAttribute.productVersions[0].productAttributes.find(attribute => attribute.code === ProductCode.ROI)?.value.toString(),
          percentage: (productAttribute.attributeCode == AttributeCode.INVESTMENT_FUND_ALLOCATION) && productAttribute.attributeValue.toString(),
        };
        this.productsDataForSwift.push(productDataForSwift);
      }
    });
    if (this.productsDataForSwift.length > 0 ) {
      this.listOfAllSubProduct.data.forEach(product => {
        const filteredProduct = product.productVersions[0].productAttributes.find(attribute => attribute.code == ProductCode.NAME);
          const productExists =  this.findInArray(filteredProduct.value.toString(), this.productsDataForSwift);
          if (!productExists) {
            const swiftProduct: ProductDataForSwift = {
              name: product.name,
              interest: `${product.productVersions[0].productAttributes.find(roi => roi.code === ProductCode.ROI).value}`,
              mph: `${product.productVersions[0].productAttributes.find(mhp => mhp.code === ProductCode.MHP_FRONTEND_DISPLAY).value}`,
              percentage: '0',
            }
            this.productsDataForSwift.push(swiftProduct);
          }
      });
    }
  }

  private findInArray(filterItem: string, filterArray: ProductDataForSwift[]): boolean {
    let isFound: boolean = false;
    filterArray.forEach((product) => {
      if (filterItem == product.name) {
        isFound = true;
      }
    });
    return isFound;
  }

  private async getSubProductsList() {
    try {
      const lenderId: string = this.storageService.getItem('lender_id');
      const subProducts = await this.productService.getSubProductsList('lender', lenderId);
      const subProductsFiltered = subProducts.data.filter(product => (new Date(product.productVersions[0].startDate).getTime() <= new Date().getTime() &&
      new Date().getTime() <= new Date(product.productVersions[0].endDate).getTime()));
      this.listOfAllSubProduct = {
        count: subProducts.count,
        data: subProductsFiltered,
        status: subProducts.status,
        total: subProducts.total,
      }
      return this.listOfAllSubProduct;
    } catch(error) {
      return Toaster.toast(`Something went wrong.`, Type.Error);
    }
  }

  async getUserAttributes() {
    const userId = this.storageService.getItem('profile_id');
    this.productDataForNCash = {
      type: null,
      frequency: '',
      date: ''
    }
    try {
      const preferences = await this.userAttributeService.getUserAttributesById(userId);
      await (preferences.count > 0) && preferences?.data.forEach(preference => {
        this.checkForPreferenceAndType(preference);
        this.populateDataForNCashDetails(preference);
      });
      if (this.productAttributes.length > 0) {
        const productDetail = await this.productService.searchProducts(this.productAttributes);
        const productDataDetail = this.checkDateRange(productDetail);
        await this.populateDataForSwiftDetails(productDataDetail);
      }
    } catch (error) {
      return Toaster.toast(`Something went wrong.`, Type.Error);
    }
  }

  async getLenderBasicInfo() {
    const lenderId: string = this.storageService.getItem('lender_id');
    this.lenderBasicInfo = await this.userAttributeService.getLenderBasicInfo(lenderId);
    if (this.lenderBasicInfo?.walletAmount != 0) {
      this.isPreferenceSet = true;
    }
    this.preferenceValue.walletAmount = this.lenderBasicInfo?.walletAmount;
    if (this.lenderBasicInfo?.lenderApplicationStatus === LenderApplicationStatus.READY_FOR_KYC ||
      this.lenderBasicInfo?.lenderApplicationStatus === LenderApplicationStatus.KYC_IN_PROGRESS) {
      this.lenderApplicationStatus = 'Your Account Verification is in Progress';
      this.kycStatusImage = '../../../../../../assets/gif/finzy-flex/kyc.svg';
    } else {
      this.router.navigate([FfEndPoints.FINZY_FLEX]);
    }

  }

  public onAddMoneyClicked(): void {
    this.storageService.saveItem(Keys.PARENT_WALLET_PATH, this.router.url);
    const matDialogConfig: MatDialogConfig = {
      height: '90%',
      width: '80%',
      panelClass: "dialog-responsive",
      data: {
        virtualAccountNumber: this.lenderBasicInfo?.virtualAccountNumber,
        fundAllocationMinimumAmount: this.fundAllocationMinimumAmount
      }
    };
    this.matDialog.open(AddFundPopupComponent, matDialogConfig);
  }
}
